import { create } from 'zustand';

import { STORAGE_KEYS } from '@constants/storageKeys';
import { USER_TYPE } from '@constants/user.constants';
import { storage } from '@utils/storage';

const isAdminUser = (user) => user?.user_type === USER_TYPE.ADMIN;

const useAuthStore = create((set) => ({
  user: null,
  accessToken: null,
  isAuthenticated: false,
  isHydrated: false,

  setAuth: ({ user = null, accessToken = null } = {}) => {
    if (accessToken) {
      storage.set(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    }

    if (user) {
      storage.set(STORAGE_KEYS.USER, user);
    }

    set({
      user,
      accessToken,
      isAuthenticated: Boolean(accessToken),
    });
  },

  clearAuth: () => {
    storage.remove(STORAGE_KEYS.ACCESS_TOKEN);
    storage.remove(STORAGE_KEYS.USER);

    set({
      user: null,
      accessToken: null,
      isAuthenticated: false,
    });
  },

  hydrateAuth: () => {
    const accessToken = storage.get(STORAGE_KEYS.ACCESS_TOKEN);
    const user = storage.get(STORAGE_KEYS.USER);

    if (accessToken && user && isAdminUser(user)) {
      set({
        user,
        accessToken,
        isAuthenticated: true,
        isHydrated: true,
      });
      return;
    }

    storage.remove(STORAGE_KEYS.ACCESS_TOKEN);
    storage.remove(STORAGE_KEYS.USER);

    set({
      user: null,
      accessToken: null,
      isAuthenticated: false,
      isHydrated: true,
    });
  },
}));

export default useAuthStore;
